/* global axios */
import ApiClient from './ApiClient';

const webs =[
  {
    id:1,
    title: 'TNW | The heart of tech',
    url: 'https://thenextweb.com',
    status: 'processing',
    updated_at: '2023-08-24T09:12:32.634Z',
    user: {
      name: 'John',
    },
  },
  {
    id:2,
    title: 'TechCrunch | Startup and Technology News',
    url: 'https://techcrunch.com',
    status: 'completed',
    updated_at: '2023-08-24T09:12:32.634Z',
    user: {
      name: 'John',
    },
  },
  {
    id:3,
    title: 'CNN: Breaking News, Latest News and Videos',
    url: 'https://edition.cnn.com',
    status: 'completed',
    updated_at: '2023-08-24T09:12:32.634Z',
    user: {
      name: 'John',
    },
  },
  {
    id:4,
    title: 'CNN: Breaking News, Latest News and Videos',
    url: 'https://edition.cnn.com',
    status: 'error',
    updated_at: '2023-08-24T09:12:32.634Z',
    user: {
      name: 'John',
    },
  },
]
const questions = [
  {
    id:1,
    question: 'How often should one conduct the UU Tube test?',
    answer: 'It is advised to test for H. pylori annually as its transmission and infection rates are high. Regular check-ups and treatments can lower the risk of future complications. Additionally, those treated for H. pylori should repeat the test at least four weeks after treatment and consult a doctor if the result is positive.',
    status: false,
    updated_at: '2023-08-24T09:12:32.634Z',
  },
  {
    id:2,
    question: 'How does PHASE Scientific use cookies on its website?',
    answer: "PHASE Scientific may use cookies to improve its website and enhance users' online experiences. Cookies are small text files stored on users' devices that help track activities on the website and remember user preferences.",
    status: false,
    updated_at: '2023-08-24T09:12:32.634Z',
  },
  {
    id:3,
    question: "What does Jason Ho do at PHASE Scientific?",
    answer: 'You can contact INDICAID lab via phone at +852 3700 8888 or via email at cs@phasesci.com.',
    status: false,
    updated_at: '2023-08-24T09:12:32.634Z',
  },
]
class Webs extends ApiClient {
  constructor() {
    super('sources/websites', { accountScoped: true });
  }
  
  get(page, perPage, sortBy, sortOrder) {
    return axios.get(this.url, {
      params: {
        page: page,
        per_page: perPage,
        sort_by: sortBy,
        sort_order: sortOrder
      }
    });
  }
  
  getURLs(websiteId, page, perPage, sortBy, sortOrder) {
    const requestURL = `${this.url}/${websiteId}/website_pages`;
    
    return axios.get(requestURL, {
      params: {
        page: page,
        per_page: perPage,
        sort_by: sortBy,
        sort_order: sortOrder
      }
    });
  }
  
  getQuestions(websiteId, page, perPage, sortBy, sortOrder, filter) {
    const requestURL = `${this.url}/${websiteId}/website_questions`;

    return axios.get(requestURL, {
      params: {
        page: page,
        per_page: perPage,
        sort_by: sortBy,
        sort_order: sortOrder
      }
    });
  }

  generateQuestions(websiteId) {
    return axios.post(`${this.url}/${websiteId}/website_pages/generate_questions`);
  }

  checkGeneratingStatus(websiteId) {
    return axios.post(`${this.url}/${websiteId}/website_pages/check_generating_status`);
  }

  updateQuestion(questionParams) {
    //sample question param
    // {
    //   id:2,
    //   question: 'How does PHASE Scientific use cookies on its website?',
    //   answer: "PHASE Scientific may use cookies to improve its website and enhance users' online experiences. Cookies are small text files stored on users' devices that help track activities on the website and remember user preferences.",
    //   status: false,
    // }
    const requestURL = `${this.url}/website_pages/generate_questions`;
    return axios.post(requestURL, questionParams);
  }

  deleteURL(website_id, website_page_id) {
    return axios.delete(`${this.url}/${website_id}/website_pages/${website_page_id}`);
  }
    
  deleteUrlResource (website_id, website_page_ids){
    return axios.post(`${this.url}/${website_id}/website_pages/delete_selected`, { website_page_ids: website_page_ids });
  }

  deleteQuestion(website_id, website_question_id) {
    return axios.delete(`${this.url}/${website_id}/website_questions/${website_question_id}`);
  }

  deleteQuestionResource (website_id, website_question_ids){
    return axios.post(`${this.url}/${website_id}/website_questions/delete_selected`, { website_question_ids: website_question_ids });
  }
}

export default new Webs();
